import addAdvertisementProperty from "./addAdvertisementProperty";

const resolveToParentId = (id, childToParentIdMap) => {
  const numericId = Number(id);
  if (!Number.isFinite(numericId)) return null;
  return childToParentIdMap?.get?.(numericId) ?? numericId;
};

const mapOverCriteo = (
  mightLikeProductItem,
  criteoAdverts,
  childToParentIdMap = new Map(),
) => {
  if (!mightLikeProductItem) return [];
  if (!criteoAdverts?.length) return mightLikeProductItem;

  const mightLikeProductId = Number(mightLikeProductItem.productId);
  const resolvedMightLikeId = resolveToParentId(
    mightLikeProductItem.productId,
    childToParentIdMap,
  );
  const ymalIds = new Set(
    [mightLikeProductId, resolvedMightLikeId].filter(Number.isFinite),
  );

  const matchingAdvert = criteoAdverts.find((criteoItem) => {
    const criteoParentSku = Number(criteoItem.ParentSKU);
    // ParentSKU is already a parent — resolving it through the map risks remapping to a different parent on ID collision.
    const resolvedCriteoProductId = resolveToParentId(
      criteoItem.ProductId,
      childToParentIdMap,
    );
    return [criteoParentSku, resolvedCriteoProductId].some((id) =>
      ymalIds.has(id),
    );
  });

  return matchingAdvert && "LineItemID" in matchingAdvert
    ? addAdvertisementProperty(mightLikeProductItem, matchingAdvert)
    : mightLikeProductItem;
};

export default mapOverCriteo;
